import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FilterCriterionUsage } from "../../api";

@Component({
    selector: 'app-confirm-filter-deletion',
    templateUrl: './confirm-filter-deletion.component.html',
    styleUrls: ['./confirm-filter-deletion.component.scss'],
    standalone: false
})
export class ConfirmFilterDeletionComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public passedData: { title: string, friendlyName: string, usages: FilterCriterionUsage[] },
    public dialogRef: MatDialogRef<ConfirmFilterDeletionComponent>
  ) {}

  get isUnused() {
    return !this.passedData.usages || this.passedData.usages.length === 0;
  }

  get venueUsages() {
    return this.passedData.usages.filter(u => !u.IsEvent);
  }

  get eventUsages() {
    return this.passedData.usages.filter(u => u.IsEvent);
  }
}
